import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { vars } from '@tgtg/kit';
import { Outlet } from 'react-router';

const LoginLayoutBase = () => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  return (
    <Stack
      direction={'column'}
      sx={{
        minHeight: '100vh',
        height: '100dvh',
        maxHeight: '100dvh',
      }}
    >
      <Box
        sx={{
          backgroundColor: vars.color.surface.neutral,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          padding: isMobile ? vars.spacing.neutral.huge : vars.spacing.neutral.gigantic,
        }}
      >
        <Stack
          direction='column'
          spacing={7}
          sx={{
            backgroundColor: vars.color.surface.background.base,
            borderRadius: vars.radius.xxlarge,
            px: isMobile ? vars.spacing.neutral.large : vars.spacing.neutral.gigantic,
            py: vars.spacing.neutral.huge,
            maxWidth: '720px',
            width: '100%',
          }}
        >
          <Outlet />
        </Stack>
      </Box>
    </Stack>
  );
};

export default LoginLayoutBase;
